/**
 * Hands requests started by index.html's inline script (see vite.config.ts, edil-prefetch) to the
 * API client, so the first screen's data downloads in parallel with the app's JavaScript instead
 * of after it. Each prefetched response is used once; anything else goes to the network.
 */
declare global {
  interface Window {
    __edilPrefetch?: Record<string, Promise<Response> | undefined>;
  }
}

export function prefetchAwareFetch(input: Request): Promise<Response> {
  const store = typeof window !== 'undefined' ? window.__edilPrefetch : undefined;
  if (store && input.method === 'GET') {
    const url = new URL(input.url);
    const key = url.pathname + url.search;
    const hit = store[key];
    if (hit) {
      delete store[key];
      return hit.then((res) => (res.ok ? res : fetch(input))).catch(() => fetch(input));
    }
  }
  return fetch(input);
}
